import { JobDetail } from '../models/job-detail.model';
export class AddJobDetail {
    static readonly type = '[JobDetail] Add';

    constructor(public payload: JobDetail) {}
}

export class UpdateJobDetail {
    static readonly type = '[JobDetail] Update';

    constructor(public payload: JobDetail) {}
}

export class RemoveJobDetail {
    static readonly type = '[JobDetail] Remove';

    constructor(public payload: JobDetail) {}
}

export class ClearJobDetail {
    static readonly type = '[JobDetail] Clear';

    constructor() {}
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/job/job-merge-customer/actions/job-detail.action.ts